(function () {
    $(function () {
        $ (".w-input-text").each (function () {
            const $_this = $ (this);
            $_this.on ("click", function (e) {
                e.preventDefault ();
                const $input = $_this.find (".b-input-text");
                if (!$input.is ("[disabled]") && !$input.is ("[readonly]")) {
                    $_this.addClass ("_focus");
                    $input.focus ();
                }
            });
        });
    
        $ (".b-input-text").each (function () {
            const $_this = $ (this);
            $_this.on ("blur", (e) => {
                if (!$_this.is ("[disabled]") && !$_this.is ("[readonly]")) {
                    $_this.closest (".w-input-text").removeClass ("_focus");
                }
            });
        });
        
        
        // // изменения атрибутов
        // const inputEls = document.getElementsByClassName ('b-input-text');
        // const observer = new MutationObserver (function (mutations) {
        //     console.log ('data-select-content-val changed');
        // });
        // Array.from (inputEls).forEach ((el) => {
        //     observer.observe (el, {
        //         attributes: true,
        //         attributeFilter: ['readonly']
        //     });
        // });
    })
}());
